module.exports = {
          srcSet: __webpack_public_path__ + "images/1969-62a312d5e3ad6f43f851abb8ae81e531-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1969-319f60960d12c1b94b0a6972f9cba100-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1969-62a312d5e3ad6f43f851abb8ae81e531-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1969-319f60960d12c1b94b0a6972f9cba100-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1969-62a312d5e3ad6f43f851abb8ae81e531-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1969-62a312d5e3ad6f43f851abb8ae81e531-320.jpg"},
          
          width: 320,
          height: 251
        }